import { REDUCERS } from '@/constants/reducers';

export function stories(state, action) {
    switch (action.type) {
        case REDUCERS.UPDATE_STORIES:
            return {
                ...state,
                stories: action.payload,
            };
        case REDUCERS.MARK_STORY_AS_VIEWED:
            return {
                ...state,
                stories: state.stories.map((story) =>
                    story.id === action.payload ? { ...story, isViewed: true } : story
                ),
            };
        default:
            return state;
    }
}
